import { render, staticRenderFns } from "./wtTwitterAutoComplete.component.vue?vue&type=template&id=21768baf&"
import script from "./wtTwitterAutoComplete.component.vue?vue&type=script&lang=js&"
export * from "./wtTwitterAutoComplete.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports